<template>
  <div id="app" class="h-full">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>


<style src="@/assets/tailwind.css"></style>
